<router-outlet>
  <app-spinner></app-spinner>
</router-outlet>
<audio id="sourceAudio" autoplay muted="true"></audio>
<audio id="remoteAudio" autoplay></audio>